module.exports = __webpack_public_path__ + "static/media/favicon.23edb5bf.ico";